module.exports = __webpack_public_path__ + "static/media/vakant.7139c9c6.png";